var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-row"},[_c('iframe',{staticStyle:{"width":"100%","border":"none","padding":"0 5px"},attrs:{"src":_vm.pageSrc,"height":"1000"}})])}
var staticRenderFns = []

export { render, staticRenderFns }